import { useEffect, useRef } from "react";
import "../../css/home.css";
import tracking from "../../img/Short_Bullet.svg";
import logoLong from "../../img/Long_bullet.svg";
import tracking1 from "../../img/ico-2.svg";
import tracking2 from "../../img/ico-3.svg";
import tracking3 from "../../img/ico-4.svg";
import tracking4 from "../../img/ico-5.svg";
import mascot from "../../img/Mascot.svg";

const DeliverySection = () => {
  const benefitBoxesRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("benefit-box-visible");
          } else {
            entry.target.classList.remove("benefit-box-visible");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    benefitBoxesRef.current.forEach((box) => {
      if (box) observer.observe(box);
    });

    return () => {
      benefitBoxesRef.current.forEach((box) => {
        if (box) observer.unobserve(box);
      });
    };
  }, []);
  return (
    <div className="container">
      <section className="delivery-section">
        {/* <div className=" row align-items-center">
          <div className="col-md-6 delivery-section-left">
            <div className="delivery-title">
              <img className="title-icon" src={tracking} alt="Tracking Icon" />
              ZTO VIỆT NAM
            </div>
            <div>
              <p>
                ZTO Việt Nam là đơn vị vận chuyển Trung - Việt, ứng dụng công
                nghệ số và AI để tối ưu tốc độ, chi phí và trải nghiệm người
                dùng.
              </p>
              <p>
                Chúng tôi cung cấp dịch vụ logistics toàn diện với kho tại Hà
                Nội, giao hàng nội địa trong 24h và tuyến Trung – Việt chỉ 2
                ngày, giúp cá nhân, shop và doanh nghiệp TMĐT vận hành hiệu quả.
              </p>
            </div>

            <button className="btn btn-primary rounded-pill p-2 px-4">
              Tìm hiểu thêm
            </button>
          </div>
          <div className="col-md-6 text-center">
            <img
              src={mascot}
              alt="Delivery Person"
              className="delivery-image"
            />
          </div>
        </div> */}
        <div>
          <div className="text-center p-2">
            <div className="core-benefits-title w-100">GIÁ TRỊ CỐT LÕI</div>
            <div className="core-benefits-subtitle d-flex justify-content-center mx-auto flex-column">
              Chúng tôi luôn cố gắng để đem tới trải nghiệm dịch vụ tốt nhất cho
              khách hàng
            </div>
          </div>
          <div className="carousel-slide">
            <div
              className="benefit-box"
              ref={(el) => (benefitBoxesRef.current[0] = el)}
            >
              <div className="item-icon">
                <img src={tracking1} alt="Tracking Icon" />
              </div>
              <p>Nhanh chóng linh hoạt</p>
              <div className="benefit-content">
                {/* Mọi đơn hàng được xử lý tự động giao đúng thời gian cam
                kết.Tuyến Trung – Việt chỉ 2 ngày,tuyến Bắc – Nam trong 24h. */}
                Mọi đơn hàng được xử lý đúng thời gian cam
                kết. Tuyến Trung – Việt chỉ 2 ngày, tuyến Bắc – Nam trong 24h.
              </div>
            </div>
            <div
              className="benefit-box"
              ref={(el) => (benefitBoxesRef.current[1] = el)}
            >
              <div className="item-icon">
                <img src={tracking2} alt="Tracking Icon" />
              </div>
              <p>
                Tối ưu chi phí
              </p>
              <div className="benefit-content">
                Bảng giá công khai, rõ ràng. Không phụ phí ẩn. Tối ưu chi phí
                cho khách hàng cá nhân lẫn doanh nghiệp.
              </div>
            </div>
            <div
              className="benefit-box"
              ref={(el) => (benefitBoxesRef.current[2] = el)}
            >
              <div className="item-icon">
                <img src={tracking3} alt="Tracking Icon" />
              </div>
              <p>
                An toàn - Bảo mật
              </p>
              <div className="benefit-content">
                Cam kết bảo vệ thông tin khách hàng và nội dung hàng hóa theo
                tiêu chuẩn quốc tế.
              </div>
            </div>
            <div
              className="benefit-box"
              ref={(el) => (benefitBoxesRef.current[3] = el)}
            >
              <div className="item-icon">
                <img src={tracking4} alt="Tracking Icon" />
              </div>
              <p> Hỗ trợ tận tâm 24/7</p>
              <div className="benefit-content">
                Sở hữu một đội ngũ tinh nhuệ, chuyên nghiệp và tận tâm, luôn sẵn sàng phục vụ khách hàng và đối tác 24/7.
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DeliverySection;
